import {Mapper} from '@s-ui/domain'

export class FromAdAggregationsRawDataToAdAggregationsListValueObjectMapper extends Mapper {
  constructor({
    adAggregationsListValueObjectFactory,
    adAggregationsValueObjectFactory,
    config,
    fromAdAggregationRawDataToAdAggregationListValueObjectMapper
  }) {
    super()
    this._adAggregationsListValueObjectFactory = adAggregationsListValueObjectFactory
    this._adAggregationsValueObjectFactory = adAggregationsValueObjectFactory
    this._fromAdAggregationRawDataToAdAggregationListValueObjectMapper =
      fromAdAggregationRawDataToAdAggregationListValueObjectMapper
    this._config = config
  }

  map = ({items: adAggregationsRawData}) => {
    const aggregationFilterNames = this._config.get('AGGREGATIONS_FILTER_NAMES')

    const items = adAggregationsRawData.map(({name, items}) => {
      const adAggregationListValueObject = this._fromAdAggregationRawDataToAdAggregationListValueObjectMapper.map({
        items
      })

      const adAggregationLitItems = adAggregationListValueObject.getItems()

      return this._adAggregationsValueObjectFactory({
        filterName: aggregationFilterNames[name],
        items: adAggregationLitItems
      })
    })
    return this._adAggregationsListValueObjectFactory({items})
  }
}
